import { twMerge } from 'src/utils/tw-merge.util'

export interface CardProps extends React.ComponentPropsWithoutRef<'div'> {
  title?: string
  topRight?: React.ReactNode
  children?: React.ReactNode
}

const Card = ({ title, children, topRight, className, ...rest }: CardProps) => {
  return (
    <div className={twMerge('c-px-6 c-pt-4 c-rounded-xl c-border-grey-300 c-border-2', className)} {...rest}>
      {title && (
        <div className="c-flex c-items-center c-justify-between c-pb-2 c-border-b c-border-grey-400">
          <h3 className="c-font-bold c-text-base">{title}</h3>
          {topRight}
        </div>
      )}
      {children}
    </div>
  )
}

export default Card
